<template>
  <div class="navigation-insights">
    <div
      class="navigation__loader"
      v-if="loading || error"
    >
      <LoadingIndicator />
    </div>
    <div
      class="navigation-insights"
      v-if="!loading && !error"
    >
        <div class="navigation-insights__filters">
            <div class="navigation-insights__filters-title">Filter by</div>
            <button v-if="hubs && hubs.length > 0"
                    class="navigation-insights__filter-button"
                    :class="{
            'navigation-insights__filter-button--active': showHubs,
          }"
                    :key="index"
                    @click="toggleHubs">
                Blogs & Hubs
            </button>
            <button class="navigation-insights__filter-button"
                    :class="{
            'navigation-insights__filter-button--active':
              category === activeCategory,
          }"
                    v-for="(category, index) in categories"
                    :key="index"
                    @click="toggleCategory(index)">
                {{ category.title }}
            </button>

            <a v-for="(externalLink, index) in externalLinks" :key="index" :href="externalLink.url" :target="externalLink.target">
                <button class="navigation-insights__filter-button">
                    {{ externalLink.name }}
                </button>
            </a>

        </div>
      <div
        class="navigation-insights__hubs"
        v-if="showHubs && hubs && hubs.length > 0"
      >
        <template
          v-for="(hub, index) in hubs"
          :key="index"
        >
          <a
            :href="hub.url"
            class="navigation-insights__hub"
            :style="`background-image:url(${hub.navigationImage})`"
            :title="hub.title"
            ><span>{{ hub.title }}</span></a
          >
        </template>
      </div>
      <div
        class="navigation-insights__results"
        v-if="!showHubs && activeArticles && activeArticles.length > 0"
      >
        <div class="navigation-insights__result-section">
          <template v-for="(article, lIndex) in activeArticles">
            <a
              class="navigation-insights__item"
              :href="article.url"
              :key="lIndex"
              v-if="lIndex < 3"
            >
              <div class="navigation-insights__item-meta">
                <span>{{ article.published }}</span>
                <span v-if="!['Podcast', 'Video'].includes(article.type)">{{
                  article.category
                }}</span>
                <span v-else
                  >{{ article.type }}
                  <i
                    :class="{
                      'icon-microphone': article.type === 'Podcast',
                      'icon-play': article.type === 'Video',
                    }"
                  ></i
                ></span>
              </div>
              <div class="navigation-insights__item-title">
                {{ article.title }}
              </div>
            </a>
          </template>
        </div>
        <div class="navigation-insights__result-section">
          <template v-for="(article, rIndex) in activeArticles">
            <a
              class="navigation-insights__item"
              :href="article.url"
              :key="rIndex"
              v-if="rIndex > 2 && rIndex < 6"
            >
              <div class="navigation-insights__item-meta">
                <span>{{ article.published }}</span>
                <span v-if="!['Podcast', 'Video'].includes(article.type)">{{
                  article.category
                }}</span>
                <span v-else
                  >{{ article.type }}
                  <i
                    :class="{
                      'icon-microphone': article.type === 'Podcast',
                      'icon-play': article.type === 'Video',
                    }"
                  ></i
                ></span>
              </div>
              <div class="navigation-insights__item-title">
                {{ article.title }}
              </div>
            </a>
          </template>
        </div>
      </div>
      <div
        class="navigation-insights__view-all"
        v-if="activeCategory"
      >
        <a
          :href="activeCategory.url"
          class="button navigation-insights__view-all-button"
        >
          View All {{ activeCategory.title }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import HubsService from "../../services/hubs";
import LoadingIndicator from "../../components/Global/LoadingIndicator.vue";

export default {
  components: {
    LoadingIndicator,
  },
  data() {
    return {
      showHubs: false,
      error: false,
      loading: true,
      insights: [],
      hubs: [],
      categories: [],
      externalLinks: [],
      activeCategory: null,
      activeArticles: [],
    };
  },
  mounted() {
    this.getHubs();
    this.getInsights();
  },
  methods: {
    toggleHubs: function () {
      this.showHubs = true;
      this.activeCategory = null;
    },
    toggleCategory: function (key) {
      this.showHubs = false;
      this.activeCategory = this.categories[key];
      this.activeArticles = this.activeCategory.insights;
    },
    getInsights: async function () {
      axios
        .post(
          "/api/insights" + `?skip=0&take=30`,
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
            this.categories = response.data.categories;           
            this.externalLinks = response.data.externalLinks;      
            
          // this.toggleCategory(0);
        })
        .catch((err) => {
          this.error = true;
        });
    },
    getHubs: async function () {
      this.loading = true;
      try {
        const hubs = await HubsService.hubs();
        this.hubs = hubs.hubs;
        this.loading = false;
        this.toggleHubs();
      } catch (error) {
        this.error = true;
      }
    },
  },
};
</script>
